import * as React from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { VenueReservationContentItemV2 } from '../../../../graphql/API';
import LinkProfile from '../../../../pages/Collabs/components/LinkProfile';
import { formatNumber } from '../../../../utils/formatter';
import UserAvatarCategory from '../../../Avatar/UserAvatarCategory/UserAvatarCategory';
import LoadingButton from '../../../Button/LoadingButton';
import SaveUserButton from '../../../Button/SaveUserButton';
import InstagramTag from '../../../InstagramTag/InstagramTag';
import { UseActionResponse } from './useAction';

export type UserHeaderProps = {
  item: VenueReservationContentItemV2 | undefined;
} & Pick<UseActionResponse, 'getLoading' | 'handleSaveUser' | 'handleInviteUser'>;

const UserHeader: React.FC<UserHeaderProps> = ({
  item,
  getLoading,
  handleSaveUser,
  handleInviteUser,
}) => {
  return (
    <Stack spacing={2} direction='row' alignItems={'flex-start'}>
      <UserAvatarCategory
        src={item?.user?.picture?.thumbnail ?? ''}
        sx={{ height: '55px', width: '55px' }}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <LinkProfile
          url={`/users/${item?.user?.id}`}
          label={`${item?.user?.firstname} ${item?.user?.lastname}`}
          fontSize='22px'
          fontWeight='500'
          hoverTextDecoration='underline'
        />
        <Stack spacing={1.5} direction='row'>
          <InstagramTag username={item?.user?.instagramHandle} textColor='#1E55A1' />
          <Typography color='#5F5F60'>
            {`${formatNumber(item?.user?.instagramFollowers ?? 0)} Followers`}
          </Typography>
        </Stack>

        <Stack spacing={1} direction='row' sx={{ mt: 2 }}>
          <SaveUserButton
            size='small'
            userId={Number(item?.user?.id)}
            saved={Boolean(item?.user?.savedByVenue)}
            onSuccess={handleSaveUser}
            isOnlineBrand
            sx={{ px: '8px', minWidth: 0 }}
          ></SaveUserButton>

          <LoadingButton
            color='primary'
            variant='outlined'
            size='small'
            sx={{ px: 3, py: 1 }}
            loading={getLoading('invite', String(item?.id))}
            onClick={handleInviteUser}
          >
            Invite {item?.user?.firstname}
          </LoadingButton>
        </Stack>
      </Box>
    </Stack>
  );
};

export default UserHeader;
